var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed bottom-3 left-3 z-30"},_vm._l((_vm.notifications),function(notification){return _c('notification-bar',{key:notification.id,staticClass:"mt-3",attrs:{"notification":notification}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }